/**
 * Layout settings for the main application appbar.
 *
 * `compactMinWidthPx`: viewport width at which the project appbar switches to
 * compact chrome (smaller logo, Help tucked into user menu). Primary nav overflow
 * is driven by available width, not only this breakpoint.
 *
 * `fullChromeMinWidthPx`: viewport width at which Help is shown inline in the bar.
 *
 * `narrowPhoneMaxWidthPx`: viewport width below which PrimaryNav shows only the
 * active section plus an overflow menu (~375px portrait phones).
 *
 * `mobileRowHeightPx`: inner appbar row height on narrow phones (Tailwind `h-16`).
 * `desktopRowHeightPx`: inner appbar row height at wider breakpoints.
 */
export const APPBAR_LAYOUT_CONFIG = {
  compactMinWidthPx: 768,
  fullChromeMinWidthPx: 1024,
  narrowPhoneMaxWidthPx: 480,
  mobileRowHeightPx: 64,
  desktopRowHeightPx: 60,
} as const;

export function getAppbarCompactMediaQuery(
  minWidthPx = APPBAR_LAYOUT_CONFIG.compactMinWidthPx,
): string {
  return `(min-width: ${minWidthPx}px)`;
}

export function getAppbarFullChromeMediaQuery(
  minWidthPx = APPBAR_LAYOUT_CONFIG.fullChromeMinWidthPx,
): string {
  return `(min-width: ${minWidthPx}px)`;
}

export function getAppbarNarrowPhoneMediaQuery(
  maxWidthPx = APPBAR_LAYOUT_CONFIG.narrowPhoneMaxWidthPx,
): string {
  return `(max-width: ${maxWidthPx}px)`;
}
